import { HeroUIProvider, Input, CheckboxGroup, Checkbox, Card, CardBody } from "@heroui/react";

const PERMS = [["view_photos", "View shipment photos"], ["view_awb", "View AWB information"], ["download_docs", "Download permitted documents"], ["approve", "Approve shipments / request changes"]];
const DEFAULT = { view_photos: true, view_awb: true, download_docs: true, approve: true };

export function ClientOpsFields({ form, setForm }) {
  const perms = form.permissions || DEFAULT;
  const selected = Object.keys(perms).filter((k) => perms[k]);
  return (
    <HeroUIProvider>
      <Card shadow="none" className="border border-[#377DD3]/25 bg-[#EAF2F8]/50" data-testid="client-ops-fields">
        <CardBody className="p-4 space-y-3">
          <p className="text-xs uppercase tracking-wide font-semibold text-[#245FAF]">Client Operations User · restricted external access</p>
          <p className="text-xs text-[#64748B]">This user only sees shipments of the selected client company that Operations has made visible. No ERP, pricing, supplier or inventory access.</p>
          <div className="grid sm:grid-cols-2 gap-3">
            <Input label="Mobile number (optional)" labelPlacement="outside" placeholder="+971 50 000 0000" variant="bordered" value={form.mobile || ""} onValueChange={(v) => setForm({ ...form, mobile: v })} data-testid="user-mobile" />
            <Input label="Job title / Department" labelPlacement="outside" placeholder="Logistics Coordinator" variant="bordered" value={form.job_title || ""} onValueChange={(v) => setForm({ ...form, job_title: v })} data-testid="user-job-title" />
          </div>
          <CheckboxGroup label="Permissions" value={selected} onValueChange={(vals) => setForm({ ...form, permissions: Object.fromEntries(PERMS.map(([k]) => [k, vals.includes(k)])) })} size="sm" data-testid="user-permissions">
            {PERMS.map(([k, l]) => <Checkbox key={k} value={k} data-testid={`perm-${k}`}>{l}</Checkbox>)}
          </CheckboxGroup>
        </CardBody>
      </Card>
    </HeroUIProvider>
  );
}
